import {Box, Chip, Grid, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {WorkforceProfileExtractedSkill} from '../../types/WorkforceProfileTypes';
import {confidenceChipSx} from '../../utils/WorkforceProfileDetail/workforceAnalysisInputConfidenceUtils';

export interface Props {
  skills: WorkforceProfileExtractedSkill[];
  confidenceLabel: (value: string) => string;
}

export const WorkforceProfileAnalysisInputExtractedSkillsList = ({skills, confidenceLabel}: Props) => (
  <Grid container spacing={0} columnSpacing={3}>
    {skills.map((row) => (
      <Grid item xs={12} md={6} key={row.skill}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1,
            py: 0.75,
            borderBottom: `1px solid ${orangeColors[3]}`,
          }}
        >
          <Box sx={{flex: 1, minWidth: 0}}>
            <Typography variant='body2'>{row.skill}</Typography>
            {row.evidence && (
              <Typography variant='caption' color='text.secondary' sx={{display: 'block', mt: 0.5, lineHeight: 1.45}}>
                {row.evidence}
              </Typography>
            )}
          </Box>
          {row.confidence && (
            <Chip
              label={confidenceLabel(row.confidence)}
              size='small'
              sx={{height: 22, fontSize: 11, fontWeight: 600, flexShrink: 0, ...confidenceChipSx(row.confidence)}}
            />
          )}
        </Box>
      </Grid>
    ))}
  </Grid>
);
